import {
  PlacementCapability,
  PlacementPreferenceType,
  PlacementSeatDeck,
  PlacementSeatPosition,
  PlacementSpaceType,
} from "@gen/travel/v1/search_pb";
import { useBookingStore } from "@stores/useBookingStore";
import { t } from "i18next";
import { useEffect, useState } from "react";
import { create } from "@bufbuild/protobuf";
import {
  PlacementWishSchema,
  PreferredSeatSchema,
} from "@gen/travel/v1/cart_pb";

type PlacementPreferenceProps = {
  placementCapability: PlacementCapability[];
  segmentId: string;
};

export default function PlacementPreference({
  placementCapability,
  segmentId,
}: PlacementPreferenceProps) {
  const [selectedSeatPosition, setSelectedSeatPosition] = useState<string>(
    PlacementSeatPosition.NO_PREFERENCE.toString(),
  );
  const [selectedSpaceType, setSelectedSpaceType] = useState<string>(
    PlacementSpaceType.NO_PREFERENCE.toString(),
  );
  const [selectedSeatDeck, setSelectedSeatDeck] = useState<string>(
    PlacementSeatDeck.NO_PREFERENCE.toString(),
  );

  const { addPlacementWish } = useBookingStore();

  const onChange = () => {
    const place = create(PreferredSeatSchema, {
      position: Number(selectedSeatPosition),
      space: Number(selectedSpaceType),
      deck: Number(selectedSeatDeck),
    });

    addPlacementWish(
      create(PlacementWishSchema, {
        segmentId: segmentId,
        wish: {
          case: "preferredSeat",
          value: place,
        },
      }),
    );
  };

  useEffect(() => {
    onChange();
  }, [selectedSpaceType, selectedSeatDeck, selectedSeatPosition]);

  return (
    <>
      {placementCapability.length > 0 && (
        <div className="flex flex-col">
          {placementCapability.map(
            (placement, index) =>
              placement.capability.case === "preference" &&
              (() => {
                switch (placement.capability.value.type) {
                  case PlacementPreferenceType.SEAT_POSITION:
                    return (
                      <div className="flex flex-col" key={index}>
                        <span className="text-sm text-gray-500">
                          {t("placement.seatPosition")}
                        </span>
                        <div className="flex items-center">
                          {placement.capability.value.options.map(
                            (option, idx: number) => (
                              <div
                                key={idx}
                                className={`flex items-center justify-center gap-2 p-4 rounded-[20px] mb-4 mt-4 border border-cnam-blue cursor-pointer mr-4 w-20 h-20 text-center text-cnam-blue ${selectedSeatPosition === option.value ? " bg-cnam-blue text-white" : "bg-white"}`}
                                onClick={() =>
                                  setSelectedSeatPosition(option.value)
                                }
                              >
                                {option.label.charAt(0).toUpperCase() +
                                  option.label.slice(1)}
                              </div>
                            ),
                          )}
                        </div>
                      </div>
                    );
                  case PlacementPreferenceType.SPACE_TYPE:
                    return (
                      <div className="flex flex-col" key={index}>
                        <span className="text-sm text-gray-500">
                          {t("placement.spaceType")}
                        </span>
                        <div className="flex items-center">
                          {placement.capability.value.options.map(
                            (option, idx: number) => (
                              <div
                                key={idx}
                                className={`flex items-center justify-center gap-2 p-4 rounded-[20px] mb-4 mt-4 border border-cnam-blue cursor-pointer mr-4 w-20 h-20 text-cnam-blue  ${selectedSpaceType === option.value ? " bg-cnam-blue text-white" : "bg-white"}`}
                                onClick={() =>
                                  setSelectedSpaceType(option.value)
                                }
                              >
                                {option.label.charAt(0).toUpperCase() +
                                  option.label.slice(1)}
                              </div>
                            ),
                          )}
                        </div>
                      </div>
                    );
                  case PlacementPreferenceType.SEAT_DECK:
                    return (
                      <div className="flex flex-col" key={index}>
                        <span className="text-sm text-gray-500">
                          {t("placement.seatDeck")}
                        </span>
                        <div className="flex items-center">
                          {placement.capability.value.options.map(
                            (option, idx: number) => (
                              <div
                                key={idx}
                                className={`flex items-center justify-center  gap-2 p-4 rounded-[20px] mb-4 mt-4 border border-cnam-blue cursor-pointer mr-4 w-20 h-20 text-center text-cnam-blue  ${selectedSeatDeck === option.value ? " bg-cnam-blue text-white" : "bg-white"}`}
                                onClick={() =>
                                  setSelectedSeatDeck(option.value)
                                }
                              >
                                {option.label.charAt(0).toUpperCase() +
                                  option.label.slice(1)}
                              </div>
                            ),
                          )}
                        </div>
                      </div>
                    );
                  default:
                    return null;
                }
              })(),
          )}
        </div>
      )}
    </>
  );
}
